import React from "react";

interface Props {
  twitter: string
}

const TwitterLink = ({ twitter }: Props) => {
  return <a href={`https://twitter.com/${twitter}`} target="_blank" rel="noreferrer">{twitter}</a>;
};

export default TwitterLink;